import * as Moment from "moment";
import { IManualDateFormatConvertible, WesternYearConverter } from ".";

export class EnglishDateFormatConverter implements IManualDateFormatConvertible {
  getEraName(): string {
    return "[A.D.]";
  }

  getShortEraName(): string {
    return "[A.D.]";
  }

  getEraNameInitial(): string {
    return "[A.D.]";
  }

  getMonthName(moment: Moment.Moment): string {
    if (!moment) {
      return "         ";
    }
    switch (moment.month()) {
      case 0: return "[January]";
      case 1: return "[February]";
      case 2: return "[March]";
      case 3: return "[April]";
      case 4: return "[May]";
      case 5: return "[June]";
      case 6: return "[July]";
      case 7: return "[August]";
      case 8: return "[September]";
      case 9: return "[October]";
      case 10: return "[November]";
      case 11: return "[December]";
      default: return "         ";
    }
  }

  getShortMonthName(moment: Moment.Moment): string {
    if (!moment) {
      return "   ";
    }
    switch (moment.month()) {
      case 0: return "[Jan]";
      case 1: return "[Feb]";
      case 2: return "[Mar]";
      case 3: return "[Apr]";
      case 4: return "[May]";
      case 5: return "[Jun]";
      case 6: return "[Jul]";
      case 7: return "[Aug]";
      case 8: return "[Sep]";
      case 9: return "[Oct]";
      case 10: return "[Nov]";
      case 11: return "[Dec]";
      default: return "   ";
    }
  }

  getDayOfWeek(moment: Moment.Moment): string {
    if (!moment) {
      return "         ";
    }
    switch (moment.weekday()) {
      case 0: return "[Sunday]";
      case 1: return "[Monday]";
      case 2: return "[Tuesday]";
      case 3: return "[Wednesday]";
      case 4: return "[Thursday]";
      case 5: return "[Friday]";
      case 6: return "[Saturday]";
      default: return "         ";
    }
  }

  getShortDayOfWeek(moment: Moment.Moment): string {
    if (!moment) {
      return "   ";
    }
    switch (moment.weekday()) {
      case 0: return "[Sun]";
      case 1: return "[Mon]";
      case 2: return "[Tue]";
      case 3: return "[Wed]";
      case 4: return "[Thu]";
      case 5: return "[Fri]";
      case 6: return "[Sat]";
      default: return "   ";
    }
  }

  getDateOrdinal(moment: Moment.Moment) {
    if (!moment) {
      return "  ";
    }
    switch (moment.date()) {
      case 11:
      case 12:
      case 13:
        return "[th]";
    }
    switch (moment.date() % 10) {
      case 1: return "[st]";
      case 2: return "[nd]";
      case 3: return "[rd]";
      default: return "[th]";
    }
  }

  /**
   * lengthは長さというよりは、実質的には変換のモードを指定している
   */
  getYear(moment: Moment.Moment, length: number): string {
    const converter = new WesternYearConverter();
    return converter.getYear(moment, length);
  }
}
